<template>
  <div id="app">

    <div class="container">
      <div class="balck" @click="$router.go(-1)">
        <img src="../assets/css/icon/fh.png" alt="">
        <span>{{$t("return")}}</span>
      </div>
      <div class="hero_m" style="margin-top: 80px" >
        <div class="title">{{ $t("become_leader") }}</div>
        <div class="text">{{ $t('commission_and_profit_sharing') }}</div>
        <div class="btn_box" @click="$router.push({ path: '/applyFor'})">{{ $t("apply_now") }}</div>
      </div>
      <div class="project ">
        <div class="modle_line_box">
          <div class="modle_line " @click="$router.push({ path: '/'})">
            {{$t("contract")}}
          </div>
          <div class="modle_line modle_line2" >
            {{$t("my_leader")}}
          </div>
        </div>

        <div class="filter-bar filter-bar11">
        </div>

        <div class="card-grid" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <div class="card" @click="goDetail(item)" v-for="(item,index) in showList" :key="index">
            <!--          <div class="card" v-for="(item,index) in 6" :key="index">-->
            <div class="card-header">
              <img class="User_avatar" :src="item.img" alt="User Avatar">
              <div>
                {{ item.username }} {{
                  item.dotAddress
                }}
                <div class="people_box">
                  <img src="../assets/css/icon/people.png">
                  <span>{{ item.molecule }}/{{ item.denominator }}</span>
                </div>
              </div>
              <div class="start_icon">
                <svg t="1745751991956" v-show="item.isStar===0" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="6229" width="200" height="200">
                  <path
                      d="M557.27 124.36l95.42 193.36A50.9 50.9 0 0 0 691 345.55l213.38 31c41.73 6.06 58.4 57.35 28.2 86.79l-154.4 150.5a50.9 50.9 0 0 0-14.64 45L800 871.4c7.13 41.57-36.5 73.27-73.83 53.64L535.31 824.71a50.83 50.83 0 0 0-47.35 0L297.11 925c-37.33 19.63-81-12.07-73.83-53.64l36.45-212.51a50.89 50.89 0 0 0-14.63-45L90.7 463.35c-30.2-29.44-13.54-80.73 28.2-86.79l213.37-31a50.9 50.9 0 0 0 38.31-27.83L466 124.36c18.67-37.81 72.6-37.81 91.27 0z"
                      fill="#474D57" p-id="6230"></path>
                </svg>
                <svg t="1745751991956" v-show="item.isStar===1" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="6229" width="200" height="200">
                  <path
                      d="M557.27 124.36l95.42 193.36A50.9 50.9 0 0 0 691 345.55l213.38 31c41.73 6.06 58.4 57.35 28.2 86.79l-154.4 150.5a50.9 50.9 0 0 0-14.64 45L800 871.4c7.13 41.57-36.5 73.27-73.83 53.64L535.31 824.71a50.83 50.83 0 0 0-47.35 0L297.11 925c-37.33 19.63-81-12.07-73.83-53.64l36.45-212.51a50.89 50.89 0 0 0-14.63-45L90.7 463.35c-30.2-29.44-13.54-80.73 28.2-86.79l213.37-31a50.9 50.9 0 0 0 38.31-27.83L466 124.36c18.67-37.81 72.6-37.81 91.27 0z"
                      fill="#A5D63F" p-id="6230"></path>
                </svg>
              </div>
            </div>
            <div class="card_line_box">
              <div class="left">
                <div class="card_info">{{$t('unrealized_profit_loss')}}</div>
                <div class="card-value" :style="{color:Number(item.unpnl)>=0?'#56BA56FF':'rgba(239, 69, 74, 1)',fontSize:'20px'}">
                  {{item.unpnl}}({{item.unpnlRate}}%)
                </div>
              </div>
              <div class="right" style="width: 180px;text-align: right;margin-right: 0px;">
                <div class="card_info">{{$t("realized_profit_loss")}}</div>
                <div class="card-value" :style="{color:Number(item.pnl)>=0?'#56BA56FF':'rgba(239, 69, 74, 1)',fontSize:'16px',fontWeight:400}">
                  {{item.pnl}}
                </div>
              </div>
            </div>
            <div class="card-details">
              <div>{{ $t("aum") }}<br>{{ item.scale }}</div>
              <div>{{ $t("trading_currency") }}<br>{{ item.currency }}</div>
              <div style="width: 150px;text-align: right;word-break: break-all;">{{$t("copy_trader_address")}}<br>{{ item.trader }}</div>
            </div>
            <div
                @click="goDetail(item,true)"
                class="card-button">{{ $t("copy_trading") }}
            </div>
          </div>
          <div class="card" v-if="!isMobile&&showList.length%3 === 2" style="border: 1px solid transparent;background: transparent"></div>        </div>
        <div class="pagination_box">
          <span>{{$t("update_every_ten_minutes")}}</span>
          <el-pagination @prev-click="prevClick()"
                         @next-click="nextClick()"
                         :page-size="pageSize"
                          layout="prev, pager, next"
                         :current-page.sync="currentPage"
                         :total="list.length" />
        </div>

      </div>
      <faq></faq>
    </div>
  </div>
</template>

<style scoped lang="scss">
.select_down{
  ::v-deep .el-input__suffix {
    .el-input__suffix-inner {
      .el-select__caret {
        font-family: 'element-icons' !important; // 确保使用 Element UI 的字体

        &.el-icon-arrow-up::before {
          content: "\e78f"; // 替换为你想用的 Element UI 图标的 Unicode 编码
        }

        &.el-icon-arrow-down::before {
          content: "\e790"; // 和展开时使用同一个图标的 Unicode
        }
      }
    }
  }
}
</style>

<script>
import {
  createAndCall,
  getContractOrder,
  getContractOrder2,
  getErc20Info,
  getLeadingInfo,
  getSelectTokenInfo
} from "../utils/contract";
import {Contract, Method, Underling} from "../config/const";
import {getAccount, requestAccount} from "../utils/wallet";
import {BigNumber} from "ethers";
import {getDotAddress, getTextWidth} from "../utils/strings";
import {isMobile, transBig2number} from "../utils/functions";
import faq from '../components/faq';
import NoAxisLineChart from "../components/NoAxisLineChart";
import {getHistoryDataAllSell} from "../service/queryService";
import {registerService, removeService} from "../service/priceService";

export default {
  name: 'Home',
  components: {
    faq,
    NoAxisLineChart
  },
  data() {
    return {
      msg:this.$t("fufuture_copy_trading"),
      list:[],
      showList:[],
      pageSize:6,
      isMobile:false,
      question:[
        {title:this.$t("what_is_copy_trading")},
        {title:this.$t("what_is_copy_trading")},
        {title:this.$t("what_is_copy_trading")}
      ],
      currentPage: 1,
      options: [
        {
          value: '1',
          label: this.$t('today')
        }, {
          value: '7',
          label:  this.$t('one_week')
        }, {
          value: '15',
          label: this.$t('half_month')
        }, {
          value: '30',
          label: this.$t('thirty_days')
        }
      ],
      value1: '0',
      value1Width:"75px",
      options1: [
        {
          value: "0",
          label:this.$t('pnl')
        },
        {
          value: '1',
          label: this.$t("profit")
        }, {
          value: '2',
          label: this.$t("loss")
        }
      ],
      value: '7',
      valueWidth:"75px",
      checked:true,
      typeqqq:0,
      questionA:'',
      loading:false
    };
  },
  methods:{
    shaixuan(){},
    search(){},
    VS(){},
    change(n){
      this.typeqqq=n
    },
    questionClick(n){
      if(n===this.questionA){
        this.questionA = ''
      }else {
        this.questionA = n
      }
    },
    prevClick(e){
      this.currentPage--
      this.getPageData(this.showList,this.list,this.currentPage)
    },
    nextClick(){
      this.currentPage++
      this.getPageData(this.showList,this.list,this.currentPage)
    },
    async getAllTraders(){

      await this.getTraders(this.list,Method.getAllLeadingContractInfoByTrader);
      await this.getPageData(this.showList,this.list,this.currentPage)
    },
    async getPageData(showData,allTraders,currentPage){
      showData.length=0;
      let end=(currentPage)*this.pageSize;
      if(allTraders.length<end){
        end=allTraders.length;
      }
      let slice=allTraders.slice((currentPage-1)*this.pageSize,end);
      showData.push(...slice);
      await this.getTraderInfo(showData);
    },
    async getTraderInfo(allTraders){
      let tokenAddress=[];
      let contractAddress=[];
      for(let i in allTraders){
        let trade=allTraders[i];
        tokenAddress.push(trade.token);
        contractAddress.push(trade.contractAddress);
      }
      let rest=await getErc20Info(tokenAddress);
      let decimals=await getErc20Info(tokenAddress,Method.decimals);
      for(let i in rest){
        allTraders[i].currency=rest[i];
      }
      let contractInfo;
      contractInfo=await getLeadingInfo(contractAddress);

      for (let i = 0; i < contractInfo.length; i += 6) {
        allTraders[i / 6].molecule = contractInfo[i + 1].length;
        allTraders[i / 6].denominator = contractInfo[i + 2].length;
        allTraders[i / 6].scale = transBig2number(contractInfo[i + 5].assetAmount);
        allTraders[i/6].trader= getDotAddress(contractInfo[i+3].traderAddress);
      }
    },
    async getTraders(allTraders,method,...args){
      let traders=await createAndCall(Contract.LeadingContractFactory,method,...args);

      let newTraders=[...traders];

      newTraders.sort((t1,t2)=>{
        return parseFloat(t2.createTime.toString())-parseFloat(t1.createTime.toString())
      })

      if(this.value1==1){
        newTraders.sort((t1,t2)=>{
          return ((t2.recentTotalBalance.sub(t2.recentTotalShare)).sub((t1.recentTotalBalance.sub(t1.recentTotalShare))).gt(BigNumber.from(0)))
        })
      }
      if(this.value1==2){
        newTraders.sort((t1,t2)=>{
          return ((t2.recentTotalBalance.sub(t2.recentTotalShare)).sub((t1.recentTotalBalance.sub(t1.recentTotalShare))).lt(BigNumber.from(0)))
        })
      }

      allTraders.length=0;
      for(let i in newTraders){
        let trade=newTraders[i];

        const des=trade.traderDescription;
        const desArr=des.split("$^");
        let headUrl="";
        if(desArr.length>1){
          headUrl=desArr[desArr.length-1];
        }
        if(headUrl){
          if(!headUrl.startsWith("http")){
            headUrl="https://admin.fufuture.io"+headUrl;
          }
        }else{
          headUrl=require("../assets/css/icon/head.svg")
        }

        allTraders.push({
          username:trade.traderName,
          type:0,
          number:'0',
          yield:'0',
          scale:'0',
          day7:'0',
          currency:'',
          base:trade.tokenName,
          molecule:'',
          denominator:'',
          contractAddress:trade.contractAddress,
          token:trade.tokenAddress,
          dotAddress:getDotAddress(trade.contractAddress),
          img:headUrl
        })
      }
    },

    handleNumber(data){
      return data[1][data[1].length-1].sub(data[0][data[0].length-1]);
    },


    async getMyTrader(){
      this.loading=true;
      let address=await getAccount();
      await this.getTraders(this.list,Method.getAllLeadingContractInfoByTrader,address);
      await this.getPageData(this.showList,this.list,this.currentPage)
      this.loading=false;
      await this.getOrderInfo(this.list);
      await this.getPnl(this.list);
    },
    goDetail(item,isFollow){
      if(document.body.clientWidth>750){
        this.$router.push({ path: '/listPage',query:{contract:item.contractAddress,token:item.token,follow:isFollow}})
      }else{
        this.$router.push({ path: '/listMobile',query:{contract:item.contractAddress,token:item.token,follow:isFollow}})
      }
    },
    async created(){
      await requestAccount()
      this.isMobile=isMobile()
      this.getMyTrader()

    },
    async getOrderInfo(traders){
      let allCalls=[];
      for(let i in traders){
        let item=traders[i];
        let selectToken=await getSelectTokenInfo(item.token)
        let calls=await getContractOrder2(item.token,item.contractAddress,selectToken.orderBook);
        allCalls=allCalls.concat(calls);
      }

      let results=await Promise.all(allCalls);
      for(let i =0 ;i<results.length;i+=4){
        let btc1={...results[i]};
        let btc2={...results[i+1]};
        let eth1={...results[i+2]};
        let eth2={...results[i+3]};

        if(btc1 && btc1.size.gt(BigNumber.from(0))){
          btc1.price = parseFloat((btc1.value.mul(BigNumber.from(10000)).div(btc1.size)).toString()) / 10000;
          traders[i/4].BTC_1=btc1;
          traders[i/4].BTC_1.direct=1;
          traders[i/4].BTC_1.vol=transBig2number(btc1.size);
          traders[i/4].BTC_1.name="BTC";
        }

        if(btc2 && btc2.size.gt(BigNumber.from(0))){
          btc2.price = parseFloat((btc2.value.mul(BigNumber.from(10000)).div(btc2.size)).toString()) / 10000;
          traders[i/4].BTC_2=btc2;
          traders[i/4].BTC_2.direct=2;
          traders[i/4].BTC_2.vol=transBig2number(btc2.size);
          traders[i/4].BTC_2.name="BTC";
        }

        if(eth1 && eth1.size.gt(BigNumber.from(0))){
          eth1.price = parseFloat((eth1.value.mul(BigNumber.from(10000)).div(eth1.size)).toString()) / 10000;
          traders[i/4].ETH_1=eth1;
          traders[i/4].ETH_1.direct=1;
          traders[i/4].ETH_1.vol=transBig2number(eth1.size);
          traders[i/4].ETH_1.name="ETH";
        }

        if(eth2 && eth2.size.gt(BigNumber.from(0))){
          eth2.price = parseFloat((eth2.value.mul(BigNumber.from(10000)).div(eth2.size)).toString()) / 10000;
          traders[i/4].ETH_2=eth2;
          traders[i/4].ETH_2.direct=2;
          traders[i/4].ETH_2.vol=transBig2number(eth2.size);
          traders[i/4].ETH_2.name="ETH";
        }
      }
    },
    calcuRate(order) {
      if (order.orderType == 1 || order.orderType == 2) {
        return "0";
      }

      let sub = BigNumber.from(0);
      if (order.direction == 1) {
        sub = BigNumber.from(order.price).sub(BigNumber.from(order.costPrice));
      } else {
        sub = BigNumber.from(order.costPrice).sub(BigNumber.from(order.price));
      }

      return transBig2number(sub.mul(order.amount).div(BigNumber.from("1000000000000000000")));
    },
    async getPnl(traders){
      let addr=[];
      for(let i in traders){
        addr.push(traders[i].contractAddress.toLowerCase());
      }
      let orders=await getHistoryDataAllSell(addr);
      let profitMap={};
      for(let i in orders.orderHistories){
        let item=orders.orderHistories[i];
        let profit=this.calcuRate(item);
        if(!profitMap[item.taker]){
          profitMap[item.taker]=0;
        }
        profitMap[item.taker]+=parseFloat(profit);
        let fee=parseFloat(transBig2number(BigNumber.from(item.tradingFee)));
        profitMap[item.taker]-=fee
      }

      for(let i in traders){
        traders[i].pnl=Number(profitMap[traders[i].contractAddress.toLowerCase()]).toFixed(2)??0;
      }

    },
    async updatePrice(prices){
      try {
        this.currentPrice = {
          BTC: transBig2number(prices[Underling.BTC].price, prices[Underling.BTC].decimal),
          ETH: transBig2number(prices[Underling.ETH].price, prices[Underling.ETH].decimal)
        }


        for (let i in this.list) {
          let item=this.list[i];
          let array=[item.BTC_1,item.BTC_2,item.ETH_1,item.ETH_2];

          let panTotal = 0;
          let marginTotal = 0;

          for(let j in array){
            let item1=array[j];
            if(!item1 || item1.size.eq(BigNumber.from(0))){
              continue;
            }
            let name = item1.name ?? "BTC";
            let currPrice = transBig2number(prices[name].price, prices[name].decimal);
            let pan = 0;
            let sub = 0;
            if (item1.direct==1) {
              sub = parseFloat(currPrice) - parseFloat(item1.price);
            } else {
              sub = -(parseFloat(currPrice) - parseFloat(item1.price));
            }
            pan = (sub * parseFloat(transBig2number(item1.size)));
            panTotal+=pan;
            marginTotal+=parseFloat(transBig2number(item1.margin));
          }

          this.list[i].unpnl=panTotal.toFixed(2);
          if(marginTotal>0){
            this.list[i].unpnlRate=(panTotal*100/marginTotal).toFixed(2);
          }else{
            this.list[i].unpnlRate=0;
          }
          this.$forceUpdate()

        }

      } catch (e) {
        console.log("error is", e);
      }
    }

  },
  created() {
    this.created()
  },
  mounted() {
    this.isMobile=isMobile()
    registerService(this.updatePrice)
    document.getElementById("header").style.display = "flex";
    document.getElementById("footer").style.display = "flex";
  },
  unmounted(){
    removeService(this.updatePrice)
  },
  watch:{
    currentPage(val1,val2){
      this.getPageData(this.showList,this.list,val1)
    },
    value1(val){
      let label="";
      for(let i in this.options1){
        if(this.options1[i].value==val){
          label=this.options1[i].label;
          break;
        }
      }
      this.value1Width=(getTextWidth(label)+45)+"px";
    },
    value(val1){
      let label="";
      for(let i in this.options){
        if(this.options[i].value==val1){
          label=this.options[i].label;
        }
      }
      this.valueWidth=(getTextWidth(label)+45)+"px";
    }

  }

}
</script>
<style src="../assets/css/celect.css"></style>
<style scoped lang="scss">
.lbt_box{
  display: flex;
  align-items: center;
  img{
    width: 85px;
    height: 90px;
    margin-top: 35px;
    margin-left: 100px;
  }
  span{
    font-size: 24px;
    font-weight: 700;
    margin-top: 50px;
    margin-left: 22px;
  }
}
::v-deep .el-carousel__indicators--horizontal {
  left: 22%;
}
.alert_box{
  width: 200px;
  display: flex;
  align-items: center;
  margin-top: 22px;
  img{
    width: 12px;
    height: 12px;
  }
  span{
    display: inline-block;
    width: 100%;
    margin-left: 8px;
  }
}
::v-deep .el-input--suffix .el-input__inner{
  height: 36px;
  line-height: 36px;
  color:#ffffff;
  border-radius: 8px;
  background: #181A20;
  //border: 1px solid #EAECEF66 !important;
  padding-right: 32px;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #ffffff;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ffffff;
  border-color: #ffffff;
}
::v-deep .el-checkbox__inner::after{
  border: 1px solid #181A20;
  border-left: 0;
  border-top: 0;
}
.ml-auto img{
  width: 18px;
  //height: 18px;
}
.card_line_box {
  display: flex;
  height: 100px;
  align-items: center;
  .left {
    flex: 1;
  }

  .right {
    width: 120px;
    margin-right: 35px;
  }
}
.pagination_box{
  margin-top: 20px;
  width: 100%;
  .el-pagination{
    float: right!important;
  }
  span{
    float: left!important;
    color: rgba(234, 236, 239, 0.5);
    margin-top: 10px;
    margin-left: 10px;
  }
}
</style>
<style lang="scss" src="../assets/css/mobile.scss"></style>

